import { Popover } from "antd";
import { useTranslation } from "react-i18next";
import { useEnumeration } from "../../../../../../common/api/queries";
import { createCommissionsSettingsRankChain } from "../../../../../commissions/ranks/utils";
import { EnumerationType } from "../../../../../enumerations/enums";
import { DashboardGoal } from "../../../../types";
import { GoalCard } from "../cards/GoalCard";

type Props = {
  goal: DashboardGoal;
  year: number;
  agentId: string;
};

export const BrokerRankWrapper = ({ goal, year, agentId }: Props) => {
  const { t } = useTranslation();

  const commissionsSettingsRanksEnums = useEnumeration(EnumerationType.COMMISSIONS_SETTINGS_RANKS);

  const rankChain = goal.actualCommissionsRank
    ? createCommissionsSettingsRankChain(commissionsSettingsRanksEnums, goal.actualCommissionsRank.id).filter(
        (option) => option.id !== goal.actualCommissionsRank?.id,
      )
    : commissionsSettingsRanksEnums;

  return (
    <GoalCard
      isGaugeStyle
      agentId={agentId}
      year={year}
      goal={goal}
      percentage={rankChain.find((rank) => rank.id === goal.targetCommissionsRank?.id) ? 0 : 100}
      label={
        <Popover content={t("dashboard.goals.helpers.rankGoalHint")}>
          {t("dashboard.enums.dashboardGoalType.BROKER_RANK")}
        </Popover>
      }
      tooltipTitle={
        <div>
          <div>
            {t("dashboard.goals.helpers.currentRank")}:{" "}
            {goal.actualCommissionsRank?.name ?? <span className="sub-header-info dashed">{t("common.none")}</span>}
          </div>
          <div>
            {t("dashboard.goals.helpers.targetRank")}: {goal.targetCommissionsRank?.name}
          </div>
        </div>
      }
      hasTarget
    />
  );
};
